module.exports = __webpack_public_path__ + "static/media/frontend.4fcf1219.svg";